import { Action, ActionCreator } from 'redux';
import { TOGGLE_DARK_MODE, DarkModeTypes } from './types';

export function toggleDarkMode(boolean: any): DarkModeTypes {
	return {
		type: TOGGLE_DARK_MODE,
		payload: boolean,
	};
}
